// The pure part of a store's Contents tab (02-DESIGN/10-state/03-indexes.md
// § the search kind): which of a store's indexes the search field queries.
// Search is the one kind today; a kind that follows is read by its own
// surface. The store's own state is not an index and is never listed here.

import { IndexKind, type NamedIndex } from "../../wire/state.ts";

/** searchIndexes are the store's search indexes, by name: what the search field may query, the first by default. */
export function searchIndexes(indexes: readonly NamedIndex[]): NamedIndex[] {
  const isSearch = (kind: string) => kind === IndexKind.search;
  return indexes.filter((ix) => isSearch(ix.kind)).sort((a, b) => a.name.localeCompare(b.name));
}

/** HISTORY_PAGE is how many changes an item's page reads at a time: the state service's default page (decision 0062). */
export const HISTORY_PAGE = 100;

/** changesLine is the count over an item's history: every change, and how many of them are shown while older ones remain. */
export function changesLine(shown: number, total: number): string {
  const n = (v: number) => v.toLocaleString("en-US");
  if (total <= shown) {
    return total === 1 ? "1 change" : `${n(total)} changes`;
  }
  return `the latest ${n(shown)} of ${n(total)} changes`;
}
